"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcancelanytime = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcancelanytime` : '') + (description ? ` desc-brandedcancelanytime` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcancelanytime"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcancelanytime"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58 29a29 29 0 1 1-58 0 29 29 0 0 1 58 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0v58a28.7 28.7 0 0 1-20.5-8.5A29.52 29.52 0 0 1 .05 29a28.9 28.9 0 0 1 8.9-20.91C14.72 2.55 21.54-.1 29 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.26 16.34a3.68 3.68 0 0 1 0 5.2l-20.8 20.8a3.68 3.68 0 0 1-5.2-5.2l20.8-20.8a3.68 3.68 0 0 1 5.2 0Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 16.34a3.68 3.68 0 0 0 0 5.2l20.8 20.8a3.68 3.68 0 0 0 5.2-5.2l-20.8-20.8a3.68 3.68 0 0 0-5.19 0Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedcancelanytime;